// D10: after a page made its own workspace current again ("Revenir à l'espace de cette page"), its reads are read again
// in place: same keys, so contents and drafts stay mounted while they refresh.
const listeners = new Set();
export function onReread(listener) {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
}
export function requestReread() {
  for (const listener of [...listeners]) {
    try { listener(); } catch { /* one reader failing never stops the others */ }
  }
}
